import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
/**
 * Testata di ogni pagina del gestionale.
 * Occhiello (12 px) → titolo (Archivo, 26 px sul telefono e 30 dal tablet) → una riga di descrizione →
 * azioni a destra. Sistema del 29-10: niente maiuscolo spaziato, titolo in font-display.
 * `back` è { to, label, testId } e mette il link di ritorno sopra l'occhiello.
 */
export default function PageHeader({ eyebrow, title, description, actions, back, testId }) {
  return (
    <header
      data-testid={testId}
      /* `flex-wrap` + una base di 20rem sulla colonna del testo: da `sm` in su
         titolo e azioni stanno sulla stessa riga finche' ci stanno DAVVERO, e
         quando non ci stanno le azioni scendono sotto invece di strizzare il
         titolo. Senza, a 640 px un titolo dell'Editor (che lo scrive il
         venditore, quindi non ha una lunghezza) finiva in una colonna da 370 px
         e prendeva CINQUE righe, mentre a 768 px ne bastavano tre. La base
         serve a far scattare il ritorno a capo: un `min-w-0` da solo si limita
         a stringere. */
      className="flex flex-col gap-group sm:flex-row sm:flex-wrap sm:items-end sm:justify-between"
    >
      <div className="min-w-0 sm:basis-80 sm:grow">
        {back ? (
          <Link
            to={back.to}
            data-testid={back.testId}
            className="-ml-2 mb-inside inline-flex h-10 items-center max-md:h-11 gap-1 rounded-sm px-2 text-body font-semibold text-ink-2 transition-colors duration-150 ease-enter hover:bg-surface-3 hover:text-ink-strong"
          >
            <ChevronLeft className="h-4 w-4" aria-hidden />
            {back.label || "Indietro"}
          </Link>
        ) : null}
        {eyebrow ? (
          <p className="text-small text-ink-3">{eyebrow}</p>
        ) : null}
        {/* Il titolo di sezione VA A CAPO, non si tronca. `truncate` metteva i
            puntini: a 390 px «Cucina open space e living — Di Marco» diventava
            «…— Di M…», cioè il nome del cliente spariva proprio dove serve.
            Su un telefono lo spazio verticale non manca, quello orizzontale sì.
            `text-balance` pareggia le due righe invece di lasciarne una monca;
            `break-words` è la rete per un codice lungo senza spazi, l'unico
            caso in cui il testo potrebbe ancora debordare. */}
        <h1 className="mt-micro text-balance break-words font-display text-h1-mobile text-ink-strong md:text-h1">
          {title}
        </h1>
        {description ? (
          <p className="mt-inside max-w-2xl text-body text-ink-2">{description}</p>
        ) : null}
      </div>
      {/* flex-wrap: sul telefono i pulsanti del sistema nuovo (42 px, testo pieno) vanno a capo invece di
          far scorrere la pagina di lato (la scheda cliente a 390 sforava di 8 px). */}
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-inside">{actions}</div> : null}
    </header>
  );
}
